interface IRR {
  id: number,
  title: string,
  author: string,
  year: number,
  filename: string,
  imgSrc?: string,
  show: boolean,
}

export const RRs: IRR[] = [
  {
    id: 6,
    title: "Spatial-Temporal-Cost Combination based Taxi Driving Fraud Detection for Collaborative Internet of Vehicles",
    author: "​​Xiangjie Kong, Bing Zhu, Guojiang Shen, Tewabe chekole Workneh, Zhanhao Ji, Yang Chen, and Zhi Liu",
    year: 2021,
    filename: "Spatial-Temporal-Cost Combination.pdf",
    imgSrc: "/images/research/Spatial_temporal_cost.png",
    show: true,
  },
  {
    id: 8,
    title: "GCN2CDD: A Commercial District Discovery Framework via Embedding Space Clustering on Graph Convolution Networks",
    author: "Guojiang Shen, Zhenzhen Zhao, Xiangjie Kong",
    year: 2021,
    filename: "GCN2CDD_A_Commercial_District_Discovery_Framework_via_Embedding_Space_Clustering_on_Graph_Convolution_Networks.pdf",
    imgSrc: "/images/research/GCN2CDD.png",
    show: true,
  },
  {
    id: 12,
    title: "Recurrent-DC: A deep representation clustering model for university profiling based on academic graph.",
    author: "Xiangjie Kong, Jiaxing Li, Luna Wang, Guojiang Shen, Yiming Sun, and Ivan Lee",
    year: 2021,
    filename: "j.future.2020.10.019.pdf",
    show: true,
  },
  {
    id: 11,
    title: "Vector Representation Learning of Papers with Text Information and Structural Identity for Recommendation",
    author: "Xiangjie Kong, Mengyi Mao, Wei Wang, Jiaying Liu, Bo Xu. VOPRec",
    year: 2021,
    filename: "TETC.2018.2830698.pdf",
    show: true,
  },
  {
    id: 10,
    title: "A Federated Learning based Cooperative Positioning Scheme for Social Internet of Vehicles",
    author: "Xiangjie Kong, Haoran Gao, Guojiang Shen, Gaohui Duan, Sajal K. Das, FedVCP",
    year: 2021,
    filename: "A Federated Learning based Cooperative Positioning Scheme for Social Internet of Vehicles.pdf",
    show: true,
  },
  {
    id: 9,
    title: "A Federated Learning-based License Plate Recognition Scheme for 5G-enabled Internet of Vehicles",
    author: "Xiangjie Kong, Kailai Wang, Mingliang Hou, Xinyu Hao, Guojiang Shen, Xin Chen, Feng Xia",
    year: 2021,
    filename: "A_Federated_Learning-Based_License_Plate_Recognition_Scheme_for_5G-Enabled_Internet_of_Vehicles.pdf",
    show: true,
  },
 
  {
    id: 7,
    title: "Real-time Mask Identification for COVID-19: An Edge Computing-based Deep Learning Framework",
    author: "Xiangjie Kong, Kailai Wang, Shupeng Wang, Xiaojie Wang, Xin Jiang, Yi Guo, Guojiang Shen, Xin Chen, and Qichao Ni",
    year: 2021,
    filename: "A Federated Learning based Cooperative Positioning Scheme for Social Internet of Vehicles.pdf",
    show: true,
  },
  {
    id: 5,
    title: "TBI2Flow: Travel behavioral inertia based long-term taxi passenger flow prediction",
    author: "​​Xiangjie Kong, Feng Xia, Zhenhuan Fu, Xiaoran Yan, Amr Tolba, Zafer Almakhadmeh",
    year: 2020,
    filename: "TBI2Flow Travel behavioral inertia based long-term taxi passenger flow prediction.pdf",
    imgSrc: "/images/research/2020TBI2Flow.png",
    show: true,
  },
  {
    id: 4,
    title: "Emergency Message Dissemination in Vehicular Networks: A Review",
    author: "​​Noor Ullah, Xiangjie Kong, Zhaolong Ning, Amr Tolba, Mubarak Alrashoud, Feng Xia",
    year: 2020,
    filename: "Emergency warning messages dissemination in vehicular social networksA trust based scheme.pdf",
    imgSrc: "/images/research/2020Emergency.png",
    show: true,
  },
  {
    id: 3,
    title: "Totally asymmetric simple exclusion process on multiplex networks",
    author: "Guojiang Shen, Xinye Fan, Zhongyuan Ruan",
    year: 2020,
    filename: "Totally asymmetric simple exclusion process on multiplex networks.pdf",
    show: true,
  },
  {
    id: 2,
    title: "HUAD: Hierarchical Urban Anomaly Detection Based on Spatio-Temporal Data",
    author: "Xiangjie Kong, Haoran Gao, Osama Alfarraj, Qichao Ni, Chaofan Zheng, Guojiang Shen",
    year: 2020,
    filename: "HUADHierarchical Urban Anomaly Detection Based on Spatio-Temporal Data.pdf",
    show: true,
  },
  {
    id: 1,
    title: "Research on Phase Combination and Signal Timing Based on Improved K-Medoids Algorithm for Intersection Signal Control",
    author: "Guojiang Shen, Xiangjie Kong, Xiangyu Zhu, Wei Xu, Longfeng Tang",
    year: 2020,
    filename: "Research on Phase Combination and Signal Timing Based on Improved K-Medoids Algorithm for Intersection Signal Control.pdf",
    show: true,
  }
]